import React from 'react'
import { hashHistory, Router, Route } from 'react-router'
import Home from './home'
import authorization from '../common/utils/authorization.js'
// import 'common/flexible'
import FastClick from 'fastclick'
import wx from '../common/utils/wx.js'

class App extends React.Component {
  componentDidMount () {
    // 初始化快速点击
    if ('addEventListener' in document) {
      document.addEventListener('DOMContentLoaded', function () {
        FastClick.attach(document.body)
      }, false)
    }
  }

  shouldComponentUpdate () {
    return false
  }

  newMain = () =>{
    authorization.isLogin()
    wx.getConfig()
  }

  render () {
    return (
      <Router history={hashHistory}>
        {/* 首页 */}
        <Route path='/' component={Home} onEnter={this.newMain} />

        <Route path='/articleDetails' onEnter={this.newMain} getComponent={(nextState, cb) => {
          require.ensure([], (require) => {
            cb(null, require('./articleDetails').default)
          }, 'articleDetails')
        }} />

        <Route path='/and' getComponent={(nextState, cb) => {
          require.ensure([], (require) => {
            cb(null, require('./and').default)
          }, 'and')
        }} />
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/routes/App.js